<template>
  <div :class="$style.zoom_slider">
    <div :class="$style.wrap">
      <label
        :class="$style.label"
        :style="{width: zoomSize}"
      >
        <div :class="$style.dots">
          <div
            v-for="dot in dots"
            :key="dot"
            :class="$style.dot"
          />
        </div>
        <input
          :class="$style.slider"
          type="range"
          step="1"
          :min="min"
          max="5"
          :value="zoom"
          @change="onChange"
        >
      </label>
    </div>
    <div :class="[$style.title, exportZoom ? $style.title_export : '']">
      {{ title }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    zoomSize: {
      type: String,
      default: '104px',
    },
    exportZoom: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'onChange',
  ],
  data() {
    return {
      zoomTitles: [
        __('zoom_scale_hours'),
        __('zoom_scale_days'),
        __('zoom_scale_weeks'),
        __('zoom_scale_months'),
        __('zoom_scale_quarters'),
        __('zoom_scale_years'),
      ],
    };
  },
  computed: {
    isWorkload() {
      return this.$store.getters['headerView/currentRoute'].path.includes('workload');
    },
    zoom() {
      return this.isWorkload ? this.$store.getters['headerView/getWorkloadZoom'] : this.$store.getters['headerView/zoom'];
    },
    min() {
      return this.isWorkload ? 1 : 0;
    },
    dots() {
      return this.zoomTitles.slice(this.min);
    },
    title() {
      return this.zoomTitles[this.zoom];
    },
  },
  methods: {
    onChange(e) {
      const zoom = +e.target.value;

      const debouncedHandler = _.debounce(value => {
        if (this.isWorkload) {
          this.$store.commit('headerView/setWorkloadZoom', value);
        } else {
          this.$store.commit('headerView/setZoom', value);
          this.$emit('onChange', value);
        }
      }, 300);

      debouncedHandler(zoom);

      function defineTimeUnit(val) {
        switch (val) {
        case 0: return 'hours';
        case 1: return 'days';
        case 2: return 'weeks';
        case 3: return 'months';
        case 4: return 'quarters';
        case 5: return 'years';
        default: return val;
        }
      }

      userExtAnalytics.log('gantt_zoom_changed', {
        'new value': defineTimeUnit(zoom),
      });
    },
  },
};
</script>

<style module lang="less" src="../less/zoomSlider.less"></style>
